import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import FacetContent from '../../lego/FacetContent';
import { useFacet } from '../../common';
const FacetButton = (_param)=>{
    var { children, buttonClassName } = _param, props = _object_without_properties(_param, [
        "children",
        "buttonClassName"
    ]);
    const { rootComponentProps, contentComponentProps, implementationSpecificProps } = useFacet(props);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: buttonClassName
    }, rootComponentProps, implementationSpecificProps), /*#__PURE__*/ React.createElement(FacetContent, contentComponentProps, children));
};
FacetButton.displayName = 'FacetButton';
export default FacetButton;

//# sourceMappingURL=FacetButton.js.map